import { http } from 'app/http/instance'

export const getPolicy = (locale: string) =>
  http.get('/api/privacy-statements', {
    populate: '*',
    locale,
  })
